define.alias("shared/components/shared/mavely/links/mobile-tabs", "preview-grid/components/shared/mavely/links/mobile-tabs");